/**
 * Created by Alex on 2018/1/10.
 */

import axios from 'axios'
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import router from '../router'
import store from '../vuex'
import UAParser from 'ua-parser-js'
Vue.use(VueCookie)

/**
 * request拦截器
 *
 */
axios.interceptors.request.use(
  config => {
    const token = Vue.cookie.get('token')
    config.headers.post['Content-Type'] = 'application/json;utf-8'
    config.headers.common['Authorization'] = token || ''
    if (config.headers.Authorization) {
      config.headers.common['Authorization'] = config.headers.Authorization
    }
    config.headers.common['deviceId'] = Vue.cookie.get('deviceId') || ''
    config.headers.common['If-Modified-Since'] = 0
    return config
  },
  error => {
    return Promise.reject(error)
  })
let device = new UAParser().getDevice()
let webpageVisibleW = document.documentElement.clientWidth || document.body.clientWidth
/**
 * response 拦截器
 * 当请求成功且code = 400时且code = 10001，用户未登录,返回登录页面
 * 当请求失败时，如果code = 400, 报错
 */
axios.interceptors.response.use(
  response => {
    if (response.config.url.indexOf('getAccessOut') > -1) {
      if (response.data.code !== 1) {
        return Promise.reject(response && response.data)
      }
      return response && response.data && response.data.data
    }
    if (response.data.code !== 1) {
      if (response.data.code === '1001') {
        router.replace({
          name: 'frontlogin'
        })
        return Promise.reject({
          msg: '登入授权失效，请重新登入！'
        })
      }
      return Promise.reject(response && response.data)
    }
    return response && response.data && response.data.data
  },
  error => {
    if (error && error.response && error.request.responseURL.indexOf('noToLogin') > -1) {
      if (error && error.response && error.response.data && error.response.data.msg) {
        return Promise.reject(error.response.data)
      }
      return Promise.reject({msg: '网络异常'})
    }
    // 前端登录到登录页
    if (error && error.response && error.request.responseURL.lastIndexOf('COMMON_DETAIL_API') > -1) {
      if ((device.type === 'mobile' && webpageVisibleW < 1200) || (device.type === 'tablet' && webpageVisibleW < 1200)) {
        router.replace({
          name: 'mobileLogin'
        })
      } else {
        router.replace({
          name: 'frontlogin'
        })
      }
      return false
    }
    // 未授权
    if (error && error.response && error.response.status === 401) {
      Vue.prototype.$message.warning('登入授权失效，请重新登入！')
      Vue.cookie.set('token', '')
      store.commit("clearUserInfo");
      if (window.location.pathname.indexOf('/admin/') === 0) {
        router.replace({
          name: 'login'
        })
      }
      else {
        router.replace({
          name: 'frontlogin'
        })
      }
    }
    else if (error && error.response && error.response.data && error.response.status === 500) {
      return Promise.reject(error.response.data)
    } else if (error && error.response && error.response.data && error.response.status === 400) {
      Vue.cookie.set('token', '')
      store.commit("clearUserInfo");

      if (window.location.pathname.indexOf('/admin/') === 0) {
        router.replace({
          name: 'login'
        })
      }
      else {
        router.replace({
          name: 'frontlogin'
        })
      }
      return Promise.reject(error && error.response && error.response.data && error.response.data.msg)
    } else {
      if (error && error.response && error.response.data && error.response.data.msg) {
        return Promise.reject(error.response.data)
      }
      return Promise.reject({msg: '网络异常'})
    }
  })

function transform (url, params) {
  if (typeof params === 'object') {
    let p = JSON.parse(JSON.stringify(params))
    for (let key in p) {
      let index = url.indexOf(`{${key}}`)
      if (index > -1) {
        url = url.replace(`{${key}}`, p[key])
        delete p[key]
      }
    }
    return { url }
  }
  return { url, params }
}

export default {
  get (resource, data) {
    let { url, params } = transform(resource, data)
    return axios.get(url, {params})
  },

  save (resource, data, body) {
    let {url, params} = transform(resource, data)
    return axios.post(url, body)
  },

  remove (resource, data) {
    let { url, params } = transform(resource, data)
    return axios.delete(url, { params })
  },

  update (resource, data, body) {
    let { url, params } = transform(resource, data)
    return axios.put(url, body, {params})
  },

  devGet (resource, data, headers) {
    let { url, params } = transform(resource, data)
    return axios.get(url, {
      headers,
      params
    })
  },

  devPost (resource, data, body, headers = {}) {
    let {url, params} = transform(resource, data)
    return axios.post(url, body, {
      headers
    })
  },
}



// WEBPACK FOOTER //
// ./src/config/axios.config.js